// Shop.js
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ProductDetailsModal from "../components/ProductDetails/ProductDetailsModal";
import { useProducts } from "../context/ProductContext";
import { IMG_URL } from "../config/config";

const Shop = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [showFilter, setShowFilter] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedAttributes, setSelectedAttributes] = useState({});

  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const categoryFromURL = query.get("category");

  const productsPerPage = 20;
  const { products, categories } = useProducts();

  useEffect(() => {
    if (categoryFromURL && categories.length > 0) {
      const matchedCategory = categories.find(
        (cat) =>
          cat.category_name.toLowerCase() === categoryFromURL.toLowerCase(),
      );
      if (matchedCategory) {
        setSelectedCategory(matchedCategory.category_id.toString());
      } else if (categoryFromURL === "all") {
        setSelectedCategory("all");
      }
    }
  }, [categoryFromURL, categories]);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedCategory, searchQuery]);

  const handleQuickView = (e, product) => {
    e.preventDefault();
    setSelectedProduct(product);
    setShowModal(true);
  };

  const toggleFilter = () => {
    setShowFilter((prev) => !prev);
    setShowSearch(false);
  };

  const toggleSearch = () => {
    setShowSearch((prev) => !prev);
    setShowFilter(false);
  };

  const filteredProducts = products.filter((p) => {
    const matchesCategory =
      selectedCategory === "all" ||
      p.category_id?.toString() === selectedCategory.toString();

    const matchesSearch = p.product_name
      ?.toLowerCase()
      .includes(searchQuery.toLowerCase());

    return matchesCategory && matchesSearch;
  });

  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = filteredProducts.slice(
    indexOfFirstProduct,
    indexOfLastProduct,
  );
  const totalPages = Math.ceil(filteredProducts.length / productsPerPage);

  return (
    <section className="bg-light py-5">
      <div className="container">
        <div className="mb-4">
          <h3 className="h3 text-dark">Product Overview</h3>
        </div>

        {/* Category Filters */}
        <div className="d-flex flex-wrap justify-content-start gap-4 category-nav mb-5">
          {[{ category_name: "All", category_id: "all" }, ...categories].map(
            (cat, idx) => {
              const value = cat.category_id?.toString();
              return (
                <div
                  key={idx}
                  className={`category-item ${
                    selectedCategory === value
                      ? "fw-bold text-dark border-bottom"
                      : "text-muted"
                  }`}
                  onClick={() => setSelectedCategory(value)}
                  role="button"
                >
                  {cat.category_name}
                </div>
              );
            },
          )}
        </div>

        {/* Filter & Search Toggle Buttons */}
        {/* <div className="d-flex justify-content-end gap-2 mb-3">
          <button
            className={`btn ${
              showSearch ? "btn-secondary" : "btn-outline-secondary"
            }`}
            onClick={toggleSearch}
          >
            {showSearch ? "✖ Search" : "🔍 Search"}
          </button>
        </div> */}

        {/* Filter Panel */}

        {/* Search Box */}
        {/* {showSearch && (
          <div className="mb-4">
            <input
              type="text"
              className="form-control"
              placeholder="🔍 Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        )} */}

        {/* Product List */}
        <div className="row g-4">
          {currentProducts.map((product, index) => {
            // const rates = product.final_rate
            //   ? JSON.parse(product.final_rate)
            //   : [];
            // const isConfigurable = product.product_type === "configuration";

            // const defaultAttr =
            //   isConfigurable && rates.length ? rates[0].attribute : "UNI";
            // const selectedAttr =
            //   selectedAttributes[product.product_id] || defaultAttr;

            // const selectedRate = isConfigurable
            //   ? rates.find((r) => r.attribute === selectedAttr)
            //   : null;

            // let price = "N/A";

            // if (isConfigurable && selectedRate) {
            //   price = parseFloat(selectedRate.finalRate);
            // } else if (!isConfigurable && rates.length) {
            //   const finalAmount =
            //     rates[0].finalAmount || rates[0].final_rate || rates[0].price;
            //   price = parseFloat(finalAmount);
            // }

            // ---- UNIVERSAL PRICE NORMALIZATION ----
            let price = null;

            // 1. Handle final_rate (configurable & simple)
            if (product.final_rate) {
              try {
                const parsed = JSON.parse(product.final_rate);
                const rateObj = parsed[0];
                price =
                  rateObj.finalAmount ??
                  rateObj.finalRate ??
                  rateObj.final_amount ??
                  rateObj.final_rate ??
                  null;
              } catch (e) {}
            }

            // 2. Handle simple price JSON
            if (!price && product.price) {
              try {
                const parsed = JSON.parse(product.price);
                const priceObj = parsed[0];
                price = priceObj.price ?? priceObj.value ?? null;
              } catch (e) {}
            }

            // 3. Fallback
            if (!price) price = null;

            return (
              <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3">
                <div className="product-card position-relative overflow-hidden">
                  <div className="product-img-wrapper">
                    {/* <img
                      src={`${IMG_URL}/uploads/${product.image}`}
                      className="img-fluid w-100"
                      alt={product.product_name}
                      style={{ height: "auto" }}
                    /> */}
                    <div
                      style={{
                        width: "100%",
                        height: "250px",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#f8f8f8",
                      }}
                    >
                      <img
                        src={`${IMG_URL}/uploads/${product.image}`}
                        alt={product.product_name}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain", // 🔥 best for no crop
                        }}
                      />
                    </div>
                    <a
                      href="/"
                      className="quick-view-btn btn btn-dark QuickViewBtn"
                      onClick={(e) => handleQuickView(e, product)}
                    >
                      Quick View
                    </a>
                  </div>
                  <div className="d-flex flex-column gap-2 pt-3 px-1">
                    {/* <a
                      href="#"
                      className="text-decoration-none text-muted d-block fw-medium"
                    >
                      {product.product_name}
                    </a> */}
                    <a
                      href="/"
                      className="text-decoration-none text-muted d-block fw-medium text-truncate"
                      style={{ maxWidth: "180px" }} // width zaroori hai
                    >
                      {product.product_name}
                    </a>
                    {/* <span className="text-muted">
                      ₹{price !== "N/A" ? price.toFixed(2) : "N/A"}
                    </span> */}
                    <span className=" text-bold">
                      ₹{price !== null ? parseFloat(price).toFixed(2) : "N/A"}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Pagination */}
        {/* {totalPages > 1 && (
          <div className="d-flex justify-content-center align-items-center gap-2 pt-4 flex-wrap">
            {[...Array(totalPages)].map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentPage(idx + 1)}
                className={`btn btn-sm ${
                  currentPage === idx + 1
                    ? "btn-dark text-white"
                    : "btn-outline-dark"
                }`}
              >
                {idx + 1}
              </button>
            ))}
          </div>
        )} */}
        <div className="d-flex justify-content-center align-items-center gap-2 pt-4 flex-wrap">
          {/* Prev Button */}
          <button
            className="btn btn-sm btn-outline-dark"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => prev - 1)}
          >
            Prev
          </button>

          {/* First Page */}
          {currentPage > 3 && (
            <>
              <button
                className={`btn btn-sm ${currentPage === 1 ? "btn-dark" : "btn-outline-dark"}`}
                onClick={() => setCurrentPage(1)}
              >
                1
              </button>
              <span className="px-2">...</span>
            </>
          )}

          {/* Middle Pages Logic */}
          {Array.from({ length: totalPages }, (_, i) => i + 1)
            .filter(
              (page) =>
                page === currentPage ||
                page === currentPage - 1 ||
                page === currentPage + 1 ||
                page === currentPage - 2 ||
                page === currentPage + 2,
            )
            .map((page) => (
              <button
                key={page}
                className={`btn btn-sm ${currentPage === page ? "btn-dark" : "btn-outline-dark"}`}
                onClick={() => setCurrentPage(page)}
              >
                {page}
              </button>
            ))}

          {/* Last Page */}
          {currentPage < totalPages - 2 && (
            <>
              <span className="px-2">...</span>
              <button
                className={`btn btn-sm ${currentPage === totalPages ? "btn-dark" : "btn-outline-dark"}`}
                onClick={() => setCurrentPage(totalPages)}
              >
                {totalPages}
              </button>
            </>
          )}

          {/* Next Button */}
          <button
            className="btn btn-sm btn-outline-dark"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((prev) => prev + 1)}
          >
            Next
          </button>
        </div>

        {/* Product Modal */}
        <ProductDetailsModal
          show={showModal}
          onClose={() => setShowModal(false)}
          product={selectedProduct}
        />
      </div>
    </section>
  );
};

export default Shop;
